import { useQuery } from "@apollo/client";
import Errors from "components/Errors";
import useRetryOn429 from "hooks/useRetryOn429";
import Spinner from "components/Spinner";
import DeliveryTableView from "./DeliveryTableView";
import { FETCH_PO_DELIVERIES } from "./graphql";

const PurchaseOrderDeliveriesView = ({ poId, odooCompanyId }) => {
  const { loading, error, data, refetch } = useQuery(FETCH_PO_DELIVERIES, {
    variables: { poId, odooCompanyId },
    fetchPolicy: "network-only",
  });
  const { isAutoRetrying } = useRetryOn429({ error, refetch });

  if (loading || isAutoRetrying) return <Spinner />;
  if (error) return <Errors error={error} />;

  const deliveries = JSON.parse(data.supplierPoDeliveries);

  const doneDeliveries = deliveries.filter((d) => d.state === "done");

  return (
    <div>
      <h5>Deliveries 交付记录</h5>

      <div className="mt-4">
        <div className="space-y-8">
          {doneDeliveries.length === 0 && (
            <div className="opacity-70">目前没有交付记录。</div>
          )}

          {doneDeliveries.map((d) => (
            <DeliveryTableView delivery={d} key={d.id} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default PurchaseOrderDeliveriesView;
